import { render, staticRenderFns } from "./BrowserBlock.vue?vue&type=template&id=adf48772&scoped=true&"
import script from "./BrowserBlock.vue?vue&type=script&lang=js&"
export * from "./BrowserBlock.vue?vue&type=script&lang=js&"
import style0 from "./BrowserBlock.vue?vue&type=style&index=0&id=adf48772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf48772",
  null
  
)

export default component.exports